import { useLpkRunContext } from './lpk-run-context';
import { NutrientSection } from './NutrientSection';

export function PotassiumSection() {
  const { selectedNutrients } = useLpkRunContext();

  return (
    selectedNutrients.potassium && (
      <NutrientSection nutrient="potassium" label="K" />
    )
  );
}
